import styled from 'styled-components'

export const TableItemWrapper = styled.div`
  border-radius: 10px;
  width: 100%;
  height: 100%;
  /* max-width: 450px; */
  transition: 0.3s;
  cursor: pointer;

  /* display: flex;
  justify-content: center;
  align-items: center; */

  // Themed Properties
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.backgroundLite};
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => `${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme }) => `${theme.colors.brand}40`};
  }
`
